import moment from "moment";
const FORMAT = "YYYY-MM-DD";

// format
// [
//   {
//    title,
//    subtitle,
//    days: [2020-01-01, 2020-01-02 etc.],
//    type
//   }
// ]
export const prepareEvents = (events) => {

  return events.map(e => {
    return {
      title: e.title[0].value,
      subtitle: e.field_subtitle.length ? e.field_subtitle[0].value : "",
     days: convertDateRangeToDays(e.field_date_range[0].value, e.field_date_range[0].end_value),
     type: e.field_event_type[0].value
    }
  })
};

const convertDateRangeToDays = (start, end) => {
  let diff = moment(end).diff(moment(start), 'days');
  let days = [];
  let startMoment = moment(start);

  days.push(start);

  if(diff > 0) {
    for(let i = 0; i < diff; i++) {
      days.push(startMoment.add(1, 'days').format(FORMAT))
    }
  }

  return days;
}

// get the newest and oldest year
export const getExtremeYears = (events) => {
    let current = moment().format(FORMAT);
    let newestDate = current;
    let oldestDate = current;
    let eventDays;

    for(let i = 0; i < events.length; i++) {
        eventDays = events[i].days;

        if(getYearsFromDate(eventDays[0]) < getYearsFromDate(oldestDate)) {
            oldestDate = eventDays[0]
        }

        if(getYearsFromDate(eventDays[0]) > getYearsFromDate(newestDate)) {
            newestDate = eventDays[0]
        }
    }

    return {
        oldest: getYearsFromDate(oldestDate),
        newest: getYearsFromDate(newestDate)
    }
}

function getYearsFromDate(date) {
    return parseInt(date.substring(0, 4));
}